export const ROUTE_PATHS = {
  LOGIN: '/auth/login',
  DASHBOARD: '/dashboard',
  REGISTER: '/join'
};
